// extracted by mini-css-extract-plugin
module.exports = {"Suspense":"Suspense_Suspense__cEK96","fadeInKeyframe":"Suspense_fadeInKeyframe__hWW0X"};